import { useLocalStorage } from 'usehooks-ts';

import { FailedPage } from '@/components/FailedPage';

import { LS_USER_BLOCKED_AT_PATH } from '@/constants/common';
import { ROUTE } from '@/constants/routes';

import { useAppDispatch } from '@/hooks/redux';

import { signOut } from '@/redux/auth/actions';

export function AgeValidationFailedPage() {
  const dispatch = useAppDispatch();
  const onBackToSignIn = () => dispatch(signOut());
  const [, setUserBlockedPath] = useLocalStorage(LS_USER_BLOCKED_AT_PATH, '');

  const onMount = () => {
    setUserBlockedPath(ROUTE.AGE_VALIDATION_FAILURE);
  };

  return (
    <FailedPage
      translationPrefix="ageValidationFailed"
      onAction={onBackToSignIn}
      testIdPrefix="age-validation-failed-page"
      onMount={onMount}
    />
  );
}

export default AgeValidationFailedPage;
